import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBloodDrop = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "blood-drop" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.5,16.147a6.75,6.75,0,0,1-13.5,0c0-4.87,4.448-12.212,6.122-14.8a.745.745,0,0,1,1.256,0C14.052,3.935,18.5,11.277,18.5,16.147Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M11.75,19.9A3.75,3.75,0,0,1,8,16.147"
		})
	]
});
export default SvgBloodDrop;
